<ng-container *ngIf="time$ | async as time; else noTime">
  {{ formatClock(start + time) }}
</ng-container>
<ng-template #noTime>--:--</ng-template>
